import React, { Component, PropTypes } from 'react';

export default class SaveButton extends Component {
    static propTypes = {
        name: PropTypes.string.isRequired,
        loadingName: PropTypes.string.isRequired,
        onClickEvent: PropTypes.func.isRequired,
        type: PropTypes.string.isRequired,
        icon: PropTypes.string
    };

    handleClick = () => {
        this.props.onClickEvent();
    };

    render() {
        if (this.props.isLoading) {
            return (
                <button type={this.props.type} className="btn blue disabled"
                        style={{width: '100%'}}
                        disabled>
                    <i className="fa fa-spinner fa-spin" aria-hidden="true"/> &nbsp;
                    {this.props.loadingName}
                </button>
            )
        }

        return (
            <button type={this.props.type} className="btn blue"
                    style={{width: '100%'}}
                    onClick={this.handleClick}>
                {this.props.name}
            </button>
        )
    }
}


/** WEBPACK FOOTER **
 ** ./src/commons/Buttons/SaveButton.js
 **/